export enum UnsplashCollections {
  helloween = '3423742',
  newYear = '1355917',
  defaultCollection = '1176653',
}



// WEBPACK FOOTER //
// ./src/constants/unsplashCollections.ts